import script from "./RecurringPaymentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecurringPaymentsPage.vue?vue&type=script&setup=true&lang=ts"

import "./RecurringPaymentsPage.vue?vue&type=style&index=0&id=6c15be6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c15be6c"]])

export default __exports__